import projectInfo from '../../../utils/project-info'
import { isEmpty } from '../../../utils'

// 各端的不同字段
const sourceMap = {
  'pur': 'purDataOrigin',
  'sur': 'surDataOrigin'
}

export const personnelSchemaHandle = {
  handle (node, {pageType}) {
    const purOrMall = projectInfo.include('pur') || projectInfo.include('mall')
    const {props, purDataOrigin, surDataOrigin, supportQuoteData} = node
    const keys = Object.values(sourceMap)
    const allData = keys.filter(v => node[v])
    props.disabled = props.disabled ||
      (purDataOrigin && surDataOrigin) ||
      (purOrMall
        ? !purDataOrigin
        : !surDataOrigin)
    props.disabledPopover = projectInfo.include('sur') ||
      (purOrMall && !purDataOrigin) ||
      !supportQuoteData
    props.currentUser = (allData.length === keys.length) && pageType === 'edit'
    // TODO 当字段为多端数据源 这里改为引用 去更新保存值
    if (props.currentUser) {
      node.supportQuoteData = false
    }
    return node
  },
  customParams: {
    event: {},
    props: {}
  }
}

export const personnelProps = {
  defaultParams: {
    type: Object,
    default () {
      return {}
    }
  },
  placeholder: {
    type: String,
    default: '请选择',
    require: true
  },
  // 是否禁用
  disabled: {
    type: Boolean,
    default: false
  },
  // 是否多选
  multiple: {
    type: Boolean,
    default: false
  },
  currentUser: Boolean,
  disabledPopover: Boolean,
  select: [Array, String],
  // 对象形式 可配置v-model返回的对象内参数
  valueKey: String,
  validateField: Function,
  // 纯文本
  isPureText: Boolean
}

function cb (value) {
  return projectInfo.include('sur') ? value.name : `${value.name}${value.code ? `（${value.code}）` : ''}`
}

export function initValue (value) {
  return (isEmpty(value) || isEmpty(value?.name)) ? '-' : cb(value) 
}